import React from 'react';
import PropTypes from 'prop-types';

function Video(props) {
  const { item } = props;
  return (
    <main className="w-full flex justify-center items-center mt-8">
      <video
        controls
        className=""
        style={{ maxHeight: '80%', maxWidth: '80%' }}
      >
        <source src={item.content.url} type="video/mp4" />
      </video>
    </main>
  );
}

Video.propTypes = {
  item: PropTypes.objectOf({
    content: PropTypes.objectOf({
      url: PropTypes.string.isRequired,
    }),
  }).isRequired,
};

export default Video;
